/**
 * 키 볼트 플랫폼 레이어(결정 #15). 앱 전역에서 단일 인스턴스를 공유한다.
 * UI/어댑터는 core의 KeyVault 인터페이스로만 다룬다(결정 #10).
 */
import type { KeyVault } from "@roqeet/core";
import { WebCryptoKeyVault } from "./key-vault.js";

export const keyVault: KeyVault = new WebCryptoKeyVault();
export { WebCryptoKeyVault } from "./key-vault.js";
